import {React,useEffect } from "react"
import {Card, CardBody} from 'react-bootstrap';
const UserDetailsLayout = ()=>{
    <Card>
        <CardBody>
            <div className="row">
                <div className="col-md-3">
                    <h4>Hello ​
ROOFTOP MEASUREMENTS</h4>
                </div>
                <div className="col-md-9"></div>
            </div>
        </CardBody>
    </Card>
}
export default UserDetailsLayout;